import {createStore} from 'redux';
import { rootReducer } from '../Reducers';

export let store = createStore(rootReducer);